import { supportsDataView } from './_setup.js';
import hasObjectTag from './_hasObjectTag.js'; // In IE 10 - Edge 13, `DataView` has string tag `'[object Object]'`.
// In IE 11, the most common among them, this problem also applies to
// `Map`, `WeakMap` and `Set`.

export var hasStringTagBug = supportsDataView && hasObjectTag(new DataView(new ArrayBuffer(8))),
    isIE11 = typeof Map !== 'undefined' && hasObjectTag(new Map());